module.exports = __webpack_public_path__ + "static/media/no-list-of-candidates.8d3ca3c9.png";